import React, { useState, useEffect } from "react";
import DataServiceSQL from "../../DataService/DataServiceSQL";
import { Row, Col } from 'reactstrap';
import { withStyles } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';
import {FormattedMessage} from 'react-intl';

const AddGateway = (props) => {
  const [gateway, setGateway] = useState({});
  const [submitted, setsubmitted] = useState(false);
  const [message, setmessage] = useState("");

  useEffect(() => {
  }, []);


  const handleInputChange = event => {
    const { name, value } = event.target;
    setGateway({ ...gateway, [name]: value });
  };


  const saveGateway = () => {
    var data = {
      resourceType: "Device",
      type: "Gateway",
      serialNumber: gateway.gw_name,
      name: gateway.nickname,
    };

    DataServiceSQL.createDeviceReq_fhir(data)
      .then(response => {
        setmessage(<FormattedMessage id="message.success" defaultMessage="Success !" />);
        setsubmitted(true);
      })
      .catch(e => {
        setmessage(<FormattedMessage id="message.error.addgw" defaultMessage="Oups, did not work... (err_code addgw)" />);
        setsubmitted(true);
      });
  };

  const { classes } = props;

  return (
    <div className={classes.popup_background}>
      <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
        <div className="submit-form">
          {submitted ? (
            <div>
              <center>
                <h4>{message}</h4>
                <button onClick={props.closeAfterAdd} className="btn btn-success">
                    <FormattedMessage id="button.close" defaultMessage="Close" />
                </button>
              </center>
            </div>
          ) : (
            <div>
              <center>
                <div>
                  <Row className="justify-content-md-end">
                    <Col style={{ fontWeight: "bold", fontSize:"2.0em" }}>
                    <FormattedMessage id="gateway.add" defaultMessage="Add gateway" />
                    </Col>
                  </Row>
                </div>
                <br/>                              
                <div className="form-group" style={{paddingTop:"5%"}}>
                  <label htmlFor="gw_name">
                    <FormattedMessage id="gateway.name" defaultMessage="Serial number" />
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="gw_name"
                    required
                    value={gateway.gw_name}
                    onChange={handleInputChange}
                    name="gw_name"
                  />
                </div>
                <br/>  
                <div className="form-group" style={{paddingTop:"5%"}}>
                  <label htmlFor="nickname">
                    <FormattedMessage id="gateway.nickname" defaultMessage="Nickname" />
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="nickname"
                    required
                    value={gateway.nickname}
                    onChange={handleInputChange}
                    name="nickname"
                  />
                </div>
                <br/>                                       
                <button onClick={props.cancelPopup} className="btn btn-danger">
                  <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
                </button>
                <b>&emsp;</b>
                <button onClick={saveGateway} className="btn btn-success">
                  <FormattedMessage id="button.submit" defaultMessage="Submit" />
                </button>
              </center>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default withStyles(Constants.styles)(AddGateway);
